var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5064 3.75C10.2706 3.75 10.037 3.7949 9.818 3.88231L9.72974 3.91754C8.83615 4.27422 8.25 5.13929 8.25 6.10144V16.5C8.25 18.5711 9.92893 20.25 12 20.25C14.0711 20.25 15.75 18.5711 15.75 16.5V6.25H17.25V16.5C17.25 19.3995 14.8995 21.75 12 21.75C9.1005 21.75 6.75 19.3995 6.75 16.5V6.10144C6.75 4.52553 7.71006 3.10862 9.17368 2.52442L9.26194 2.48919C9.65782 2.33118 10.0802 2.25 10.5064 2.25C10.9327 2.25 11.355 2.33118 11.7509 2.48919L11.8391 2.52442C13.3028 3.10862 14.2628 4.52554 14.2628 6.10144V15.9133C14.2628 17.2038 13.2166 18.25 11.9261 18.25C10.6356 18.25 9.58938 17.2038 9.58938 15.9133V6.25H11.0894V15.9133C11.0894 16.3754 11.464 16.75 11.9261 16.75C12.3882 16.75 12.7628 16.3754 12.7628 15.9133V6.10144C12.7628 5.13929 12.1767 4.27422 11.2831 3.91754L11.1948 3.88231C10.9758 3.7949 10.7422 3.75 10.5064 3.75Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/Attachment.0ae91313eed13983a16170890327f956.svg";
export { ForwardRef as ReactComponent };